import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Button,
  Checkbox,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import React, { useCallback, useEffect, useState } from "react";
import { Field, Form } from "react-final-form";
import Header from "../../Header";
import InsureeMedicalStatus from "../../pickers/InsureeMedicalStatus";
import InsureePicker from "../../pickers/InsureePicker";
import MedicalOfficerPicker from "../../pickers/MedicalOfficerPicker";
import VerificationPicker from "../../pickers/VerificationPicker";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import { PreAuthDocs } from "./PreAuthDocs";
import { PreAuthMedical } from "./PreAuthMedical";
import { PreAuthServiceAct } from "./PreAuthServiceAct";
import { PreAuthServiceExam } from "./PreAuthServiceExam";
// import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { getPreAuthDataById, savePreAuth, submitApproval } from "../../action";
import { decodeId } from "../../utils/helper";

import CircularProgress from "@mui/material/CircularProgress";
import { useQuery } from "../../Header";
import { useConvention } from "../../hooks/useConvention";
import CommonSnackbar from "../../reusableComponents/components/generics/CommonSnackbar";
import { Pre_Autharization } from "../../utils/constant";
import PreAuthHistory from "./PreAuthHistory";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

const PreAuthDetails = () => {
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const idWithPrefix = pathname.split("/").pop();
  const url = idWithPrefix.split("=")[1];
  const [InsureeCode, setInsureeCode] = useState(
    SignInSuccess?.profileReducer?.insureeByIdResponseData
  );
  const [serviceClaimData, setServiceClaimData] = useState([]);
  const [serviceExaminationData, setServiceExaminationData] = useState([]);
  const [itemsServiceData, setItemsServiceData] = useState([]);
  const [attachments, setAttachments] = useState();
  const [preAuthFormData, setPreAuthFormData] = useState();
  const hf_Uuid =
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees?.[0]?.uuid;
  const insureeData = useSelector(
    (state) => state?.fosaReducer?.InsureeUuidData
  );
  const substituteData = useSelector(
    (state) => state?.fosaReducer?.SubstituteData
  );
  const InsureecamuNumber =
    SignInSuccess?.profileReducer?.insureeByIdResponseData?.[0]?.camuNumber;
  const userData = useSelector((state) => state.profileReducer);

  const HfInsuree = useSelector((state) => state?.fosaReducer?.HfInsuree);
  const [serviceActTotal, setServiceActTotal] = useState(0);
  const [serviceActTMValue, setServiceActTMValue] = useState(0);
  const [serviceExamTMValue, setServiceExamTMValue] = useState(0);
  const [serviceMediMValue, setServiceMediTMValue] = useState(0);

  const [serviceActSupportTotal, setServiceActSupportTotal] = useState(0);
  const [serviceExamSupportTotal, setServiceExamSupportTotal] = useState(0);
  const [serviceMedicalSupportTotal, setServiceMedicalSupportTotal] = useState(0);

  const [haveMedicalItem, setHaveMedicalItem] = useState(false);
  const [haveMedicalAct, setHaveMedicalAct] = useState(false);
  const [haveExamen, setHaveExamen] = useState(false);
  const [verificationWithoutBiometry, setVerificationWithoutBiometry] =
    useState(false);

  const [serviceExamTotal, SetServiceExamTotal] = useState(0);
  const [serviceMedicalTotal, setServiceMedicalTotal] = useState(0);
  const [totalClaimed, setTotalClaimed] = useState(0);
  const query = useQuery();

  const [saving, setSaving] = useState(false);
  const [snackbarOption, setSnackbarOption] = useState({
    visible: false,
    message: "",
    severity: "",
  });

  const closeSnackbar = useCallback(() => {
    setSnackbarOption({
      visible: false,
      message: "",
      severity: "",
    });
  }, []);

  const [initialValues, setInitialValues] = useState({
    insureeNo: "",
    insureeVerification: "",
    camuDoctor: "",
    substitutionDoctor: "",
    comments: "",
  });

  const { isConventionnementActive } = useConvention();

  const [substitutionChecked, setSubstitutionChecked] = useState(false);

  useEffect(() => {
    if (preAuthFormData) {
      const jsonExtData = preAuthFormData[0]?.jsonExt
        ? JSON.parse(preAuthFormData[0].jsonExt)
        : {};

      setInitialValues({
        insureeNo: preAuthFormData[0]?.insuree?.camuNumber || "",
        insureeVerification: preAuthFormData[0]?.insureeVerification?.id || "",
        camuDoctor: jsonExtData?.camuDoctor?.uuid || "",
        substitutionDoctor: jsonExtData?.substitutionDoctor?.uuid || "",
        comments: preAuthFormData[0]?.comments || "",
      });

      if (jsonExtData?.substitutionDoctor?.uuid) {
        setSubstitutionChecked(true);
      }
    }
  }, [preAuthFormData]);

  useEffect(() => {
    const category =
      SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.category;
    if (category) {
      setHaveMedicalItem(category.haveMedicalItem);
      setHaveMedicalAct(category.haveMedicalAct);
      setHaveExamen(category.haveExamen);
      setVerificationWithoutBiometry(category.verificationWithoutBiometry);
    }
  }, [SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.category]);

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setInsureeCode(SignInSuccess?.profileReducer?.insureeByIdResponseData);
  }, [SignInSuccess?.profileReducer?.insureeByIdResponseData]);

  const transFormMedicalInfo = (medicalInformationArray, selectedUuid) => {
    // Find the medical information object that matches the selected UUID
    const selectedMedicalInformation = medicalInformationArray.find(
      (info) => info.uuid === selectedUuid
    );
    // If a matching object is found, transform the data
    if (selectedMedicalInformation) {
      let transformData = {
        camuDoctor: {
          id: selectedMedicalInformation.id,
          uuid: selectedMedicalInformation.uuid,
          chfId: selectedMedicalInformation.chfId,
          lastName: selectedMedicalInformation.lastName,
          otherNames: selectedMedicalInformation.otherNames,
          camuNumber: selectedMedicalInformation.camuNumber,
          education: selectedMedicalInformation.education,
        },
      };
      return transformData;
    } else {
      // If no matching object is found, return null or handle the case as needed
      return null;
    }
  };

  const handleSubmitForApproval = async () => {
    try {
      const res = await submitApproval(decodeId(preAuthFormData[0]?.id));
      setSnackbarOption({
        visible: true,
        message: "Votre demande d'accord préalable à bien été soumis!",
        severity: "success",
      });
      console.log("response", res);
      navigate(Pre_Autharization);
    } catch (e) {
      console.error(e);
      setSnackbarOption({
        visible: true,
        message:
          "Une erreur est survenu lors de la soumission de la demande d'accord préalable!",
        severity: "success",
      });
    }
  };

  const onSubmit = async (values) => {
    const medicalInformation = values.camuDoctor;
    const medicalInfoPayload = transFormMedicalInfo(
      HfInsuree,
      medicalInformation
    );

    const subData = substituteData?.[0];

    if (subData && substitutionChecked) {
      medicalInfoPayload.substitutionDoctor = {
        camuNumber: subData?.camuNumber,
        chfId: subData?.chfId,
        education: subData?.education,
        id: subData?.id,
        lastName: subData?.lastName,
        otherNames: subData?.otherNames,
        uuid: subData?.uuid,
      };
    }

    if (!serviceClaimData?.length && !serviceExaminationData?.length && !itemsServiceData?.length) {
      return setSnackbarOption({
        visible: true,
        message:
          "Vous devez ajouter au moins un acte, un examen ou un produit",
        severity: "error",
      });
    }

    const payload = {
      insureeId: decodeId(
        SignInSuccess?.profileReducer?.insureeByIdResponseData?.[0]?.id
      ),
      comments: values.comments,
      insureeVerificationId: decodeId(values.insureeVerification),
      jsonExt: medicalInfoPayload,
      healthFacilityId:
        userData?.currentUserResponseData?.i_user?.health_facility_id,
      services: [...serviceClaimData, ...serviceExaminationData],
      items: [...itemsServiceData],
      attachments: attachments,
    };

    if (url) {
      payload["uuid"] = decodeId(preAuthFormData[0]?.id);
    }

    setSaving(true);

    try {

      const { success, ...rest } = await savePreAuth(payload);
      if (!success) {
        console.error("Unable to submit preAuth, server response", rest);
        setSnackbarOption({
          visible: true,
          message:
            rest.message ??
            "Une erreur s'est produite lors de la création de l'accord préalable",
          severity: "error",
        });
        return;
      }

      setSnackbarOption({
        visible: true,
        message: "La demande d'accord préalable à bien été crée",
        severity: "success",
      });

      navigate(Pre_Autharization);
    } catch (e) {
      console.error(e);
      setSnackbarOption({
        visible: true,
        message: "Une erreur inatendu est survenu, veuillez réessayer!",
        severity: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (url) {
      let decodedID = decodeId(url);
      dispatch(getPreAuthDataById(decodedID));
    }
  }, []);

  useEffect(() => {
    if (url) {
      if (SignInSuccess?.fosaReducer?.PreAuthFormData) {
        setPreAuthFormData(SignInSuccess?.fosaReducer?.PreAuthFormData);
      }
    } else {
      setPreAuthFormData(null);
      setInsureeCode(null);
      setInsureeCode(null);
    }
  }, [SignInSuccess?.fosaReducer?.PreAuthFormData]);

  const handleClaimDataChange = (newData) => {
    const formattedData = newData.map((row) => ({
      // PreAuthServiceAct uses acts: actId; legacy/exam may use serviceId
      serviceId: row.actId ?? row.serviceId,
      priceAsked: row.price,
      qtyProvided: row.quantity,
      status: 1,
      jsonExt: JSON.stringify({
        countedPrice: row.countedPrice,
        tmValue: row.tmValue,
      }),
    }));
    setServiceClaimData(formattedData);
  };

  const handleExaminationData = (newData) => {
    const formatedData = newData.map((row) => ({
      // PreAuthServiceExam uses examination acts: actId; legacy may use serviceId
      serviceId: row.actId ?? row.serviceId,
      priceAsked: row.price,
      qtyProvided: row.quantity,
      status: 1,
      jsonExt: JSON.stringify({
        countedPrice: row.countedPrice,
        tmValue: row.tmValue,
      }),
    }));
    setServiceExaminationData(formatedData);
  };

  const handleItemsData = (newData) => {
    const formatedData = newData.map((row) => ({
      // PreAuthMedical uses product bundle: productId; legacy may use itemId
      itemId: row.productId ?? row.itemId,
      priceAsked: row.price,
      qtyProvided: row.quantity,
      status: 1,
      jsonExt: JSON.stringify({
        countedPrice: row.countedPrice,
        tmValue: row.tmValue,
      }),
    }));
    setItemsServiceData(formatedData);
  };

  const getServiceActTotal = (total) => {
    setServiceActTotal(total);
  };

  const getServiceExamTotal = (total) => {
    SetServiceExamTotal(total);
  };

  const getMedicalTotal = (total) => {
    setServiceMedicalTotal(total);
  };

  const getServiceActTM = (total) => {
    setServiceActTMValue(total);
  };

  const getServiceExamTM = (total) => {
    setServiceExamTMValue(total);
  };

  const getServiceMedicalTM = (total) => {
    setServiceMediTMValue(total);
  };

  const getClaimTotal = () => {

    return serviceActSupportTotal + serviceExamSupportTotal + serviceMedicalSupportTotal;
    // return serviceActTotal + serviceExamTotal + serviceMedicalTotal;
  };

  const getClaimTMTotal = () => {

    return serviceActTMValue + serviceExamTMValue + serviceMediMValue;
  };

  const validate = (values) => {
    const errors = {};
    if (url) return errors;

    if (!values.insureeNo) {
      errors.insureeNo = t("Field is required");
    }

    if (!values.camuDoctor) {
      errors.camuDoctor = t("Field is required");
    }

    if (substitutionChecked && !values.substitutionDoctor) {
      errors.substitutionDoctor = t("Field is required");
    }

    if (!values.insureeVerification) {
      errors.insureeVerification = t("Field is required");
    }

    return errors;
  };

  const handleCheckSubstitution = (e) => {
    setSubstitutionChecked((state) => !state);

    if (!e.currentTarget.checked) {
      console.log("===>", e.currentTarget.checked);
    }
  };

  const disabled = preAuthFormData?.[0]
    ? [-1, 2, 4].includes(preAuthFormData[0]?.status) ||
    !isConventionnementActive
    : false;

  const cannotBeSentWithActualStatus = preAuthFormData?.[0]
    ? preAuthFormData[0].isApproved
    : true; // || preAuthFormData[0].isSubmitted : true

  const hideMenu = query.get("hideMenuNavigation");

  return (
    <Grid>
      <Header
        navigate={goBack}
        children={
          <div>
            <Grid>
              {!hideMenu && (
                <Grid>
                  <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={goBack}
                    style={{ marginLeft: ".5rem", color: "black" }}
                  >
                    {t("back")}
                  </Button>
                  <Grid>
                    <Typography style={{ marginLeft: "1.2rem" }} variant="h6">
                      {t("preAuthTitle")}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              <Form
                onSubmit={onSubmit}
                validate={validate}
                initialValues={initialValues}
                render={({
                  handleSubmit,
                  values,
                  submitting,
                  errors,
                  pristine,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid>
                      <StyledPaper>
                        <StyledPaperHeader>
                          <Typography variant="h6">
                            {t("InsureeInformation")}
                          </Typography>
                        </StyledPaperHeader>
                        <Grid
                          container
                          style={{ margin: ".5rem", display: "flex" }}
                        >
                          <Grid className="common-input">
                            <Field
                              name="insureeNo"
                              component={InsureePicker}
                              label={t("TemporaryCAMU")}
                              required
                              type="text"
                              insureeNo={values}
                              requiredCamuNumber={true}
                              disabled={initialValues?.insureeNo}
                            />
                          </Grid>
                          {!(preAuthFormData && preAuthFormData[0]?.id) && (
                            <Grid
                              item
                              xs={3}
                              className="common-input"
                              style={{ marginTop: "2px" }}
                            >
                              <Field
                                name="insureeVerification"
                                component={VerificationPicker}
                                label={t("VerificationCode")}
                                hfUuid={InsureecamuNumber}
                                verificationWithoutBiometry={
                                  verificationWithoutBiometry
                                }
                                insureeVerification={values.insureeVerification}
                              />
                            </Grid>
                          )}

                          {preAuthFormData && preAuthFormData[0]?.id && (
                            <Grid
                              item
                              xs={3}
                              className="common-input"
                              style={{ marginTop: "2px" }}
                            >
                              <TextInput
                                name="insureeVerification"
                                value={
                                  preAuthFormData[0]?.insureeVerification
                                    ?.verificationCode
                                    ? preAuthFormData[0]?.insureeVerification
                                      ?.verificationCode
                                    : ""
                                }
                                label={t("verifivationTextbox")}
                                type="text"
                                disabled={true}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </StyledPaper>
                    </Grid>

                    {/* Insuree Information */}
                    <Grid>
                      <StyledPaper>
                        <StyledPaperHeader>
                          <Typography variant="h6">
                            {t("InsureeInformation")}
                          </Typography>
                        </StyledPaperHeader>
                        <Grid
                          container
                          style={{ margin: ".5rem .5rem .5rem .5rem" }}
                        >
                          <Grid item xs={3} className="common-input">
                            <TextInput
                              name="camuCode"
                              label={t("CAMUCode")}
                              value={
                                InsureeCode?.[0]?.policyholderinsureeSet
                                  ? InsureeCode?.[0]?.policyholderinsureeSet
                                    ?.edges?.[0]?.node?.policyHolder?.code
                                  : ""
                              }
                              type="text"
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={3} className="common-input">
                            <TextInput
                              name="tradeName"
                              value={
                                InsureeCode?.[0]?.policyholderinsureeSet
                                  ? InsureeCode?.[0]?.policyholderinsureeSet
                                    ?.edges?.[0]?.node?.policyHolder
                                    ?.tradeName
                                  : ""
                              }
                              label={t("Trade Name")}
                              type="text"
                              disabled={true}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            className="common-input"
                            style={{ marginTop: "2px" }}
                          >
                            <TextInput
                              name="camuNumber"
                              value={
                                InsureeCode?.[0]?.chfId
                                  ? InsureeCode?.[0]?.chfId
                                  : ""
                              }
                              label={t("CAMUNo.")}
                              type="text"
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={3} className="common-input">
                            <TextInput
                              name="givenName"
                              value={
                                InsureeCode?.[0]?.otherNames
                                  ? InsureeCode?.[0]?.otherNames
                                  : ""
                              }
                              label={t("GivenName")}
                              type="text"
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={3} className="common-input">
                            <TextInput
                              name="insureeName"
                              value={
                                InsureeCode?.[0]?.otherNames
                                  ? InsureeCode?.[0]?.otherNames
                                  : ""
                              }
                              label={t("Insuree Name")}
                              type="text"
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={3} className="common-input">
                            <TextInput
                              name="insureeCamuNumber"
                              value={
                                InsureeCode?.[0]?.camuNumber
                                  ? InsureeCode?.[0]?.camuNumber
                                  : ""
                              }
                              label={t("InsureeCamuNo")}
                              type="text"
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={3} className="common-input">
                            <TextInput
                              name="insureeAge"
                              value={
                                InsureeCode?.[0]?.age
                                  ? InsureeCode?.[0]?.age
                                  : ""
                              }
                              label={t("Age")}
                              type="text"
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={3} className="common-input">
                            <TextInput
                              name="insureeGender"
                              value={
                                InsureeCode?.[0]?.gender?.gender
                                  ? InsureeCode?.[0]?.gender?.gender
                                  : ""
                              }
                              label={t("Gender")}
                              type="text"
                              disabled={true}
                            />
                          </Grid>
                        </Grid>
                      </StyledPaper>
                    </Grid>

                    {/* Medical Information */}
                    <Grid>
                      <StyledPaper>
                        <StyledPaperHeader>
                          <Typography variant="h6">
                            {t("MedicalInformation")}
                          </Typography>
                        </StyledPaperHeader>
                        <Grid container style={{ margin: ".5rem" }}>
                          <Grid item xs={3} className="common-input">
                            <Field
                              name="camuDoctor"
                              component={MedicalOfficerPicker}
                              label={t("DoctorCamuNo.*")}
                              hf_Uuid={hf_Uuid}
                              value={"test"}
                              disabled={disabled}
                            />
                          </Grid>
                          {values.camuDoctor && (
                            <>
                              <Grid item xs={3} className="common-input">
                                <TextInput
                                  name="lastName"
                                  value={
                                    insureeData?.[0]?.lastName
                                      ? insureeData?.[0]?.lastName
                                      : ""
                                  }
                                  label={t("Last Name")}
                                  type="text"
                                  disabled
                                />
                              </Grid>
                              <Grid item xs={3} className="common-input">
                                <TextInput
                                  name="firstName"
                                  value={
                                    insureeData?.[0]?.otherNames
                                      ? insureeData?.[0]?.otherNames
                                      : ""
                                  }
                                  label={t("First Name")}
                                  type="text"
                                  disabled
                                />
                              </Grid>
                              <Grid item xs={3} className="common-input">
                                <TextInput
                                  name="education"
                                  value={
                                    insureeData?.[0]?.education
                                      ? insureeData?.[0]?.education
                                      : ""
                                  }
                                  label={t("Education")}
                                  type="text"
                                  disabled
                                />
                              </Grid>
                              <Grid item xs={3} className="common-input">
                                <InsureeMedicalStatus
                                  name="fosaStatus"
                                  label={t("fosaStatus")}
                                  type="text"
                                  disabled={true}
                                  hf_Uuid={hf_Uuid}
                                  values={values.camuDoctor}
                                />
                              </Grid>
                            </>
                          )}
                        </Grid>
                        <Grid item display={"flex"} alignItems={"center"}>
                          <Checkbox
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 35 },
                            }}
                            onChange={(checked) =>
                              handleCheckSubstitution(checked)
                            }
                            checked={substitutionChecked}
                            disabled={disabled}
                          />
                          <Typography
                            color="#666666"
                            style={{ cursor: "pointer" }}
                          >
                            {t("substitutionRequest")}
                          </Typography>
                        </Grid>
                        {substitutionChecked && (
                          <Grid container style={{ margin: ".5rem" }}>
                            <Grid item xs={3} className="common-input">
                              <Field
                                name="substitutionDoctor"
                                component={MedicalOfficerPicker}
                                label={t("DoctorCamuNo.*")}
                                hf_Uuid={hf_Uuid}
                                value={"test"}
                                substitute={true}
                                principalDoctor={values.camuDoctor}
                              />
                            </Grid>
                            {values.substitutionDoctor && (
                              <>
                                <Grid item xs={3} className="common-input">
                                  <TextInput
                                    name="lastName"
                                    value={
                                      substituteData?.[0]?.lastName
                                        ? substituteData?.[0]?.lastName
                                        : ""
                                    }
                                    label={t("Last Name")}
                                    type="text"
                                    disabled
                                  />
                                </Grid>
                                <Grid item xs={3} className="common-input">
                                  <TextInput
                                    name="firstName"
                                    value={
                                      substituteData?.[0]?.otherNames
                                        ? substituteData?.[0]?.otherNames
                                        : ""
                                    }
                                    label={t("First Name")}
                                    type="text"
                                    disabled
                                  />
                                </Grid>
                                <Grid item xs={3} className="common-input">
                                  <TextInput
                                    name="education"
                                    value={
                                      substituteData?.[0]?.education
                                        ? substituteData?.[0]?.education
                                        : ""
                                    }
                                    label={t("Education")}
                                    type="text"
                                    disabled
                                  />
                                </Grid>
                                <Grid item xs={3} className="common-input">
                                  <InsureeMedicalStatus
                                    name="fosaStatus"
                                    label={t("fosaStatus")}
                                    type="text"
                                    hf_Uuid={hf_Uuid}
                                    substitutionDoctor={
                                      values.substitutionDoctor
                                    }
                                    value={"test"}
                                    substitute={true}
                                    principalDoctor={values.camuDoctor}
                                    disabled={disabled}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                        )}
                      </StyledPaper>
                    </Grid>



                    {/* Service Details */}
                    {haveMedicalAct && (
                      <Grid style={{ margin: "1rem" }}>
                        <PreAuthServiceAct
                          onDataChange={handleClaimDataChange}
                          updateTotalClaimed={getServiceActTotal}
                          updateTMvalue={getServiceActTM}
                          claimData={preAuthFormData && preAuthFormData[0]}
                          disabled={disabled}
                          updateSupportTotal={setServiceActSupportTotal}
                        />
                      </Grid>
                    )}



                    {haveExamen && (
                      <Grid style={{ margin: "1rem" }}>
                        <PreAuthServiceExam
                          onDataChange={handleExaminationData}
                          updateTotalClaimed={getServiceExamTotal}
                          updateTMvalue={getServiceExamTM}
                          claimData={preAuthFormData && preAuthFormData[0]}
                          disabled={disabled}
                          updateSupportTotal={setServiceExamSupportTotal}
                        />
                      </Grid>
                    )}



                    {haveMedicalItem && (
                      <Grid style={{ margin: "1rem" }}>
                        <PreAuthMedical
                          onDataChange={handleItemsData}
                          updateTotalClaimed={getMedicalTotal}
                          updateTMvalue={getServiceMedicalTM}
                          claimData={preAuthFormData && preAuthFormData[0]}
                          disabled={disabled}
                          updateSupportTotal={setServiceMedicalSupportTotal}
                        />
                      </Grid>
                    )}

                    <Grid item margin="1rem" borderRadius={"4px"}>
                      <Grid
                        item
                        backgroundColor="#00913E"
                        color="white"
                        display="flex"
                        justifyContent="space-between"
                        padding="2px 10px"
                      >
                        <Typography variant="h6">{t("GrandTotal")}</Typography>
                        <Typography variant="h6">
                          {t("TotalSupportedbyInsuree")}
                        </Typography>
                        <Typography variant="h6">
                          {t("TotalSupportedbyCamu")}
                        </Typography>
                      </Grid>
                      <Grid
                        tem
                        backgroundColor="#fffff"
                        color="black"
                        display="flex"
                        justifyContent="space-between"
                        padding="2px 10px"
                      >
                        <Typography variant="h6">{t("Total")}</Typography>

                        <Typography variant="h6">
                          {"XAF " + getClaimTMTotal()}
                        </Typography>
                        <Typography variant="h6">
                          {"XAF " + getClaimTotal()}
                        </Typography>
                      </Grid>
                    </Grid>

                    {/* Comment Section */}
                    <StyledPaper>
                      <StyledPaperHeader
                        container
                        alignItems="center"
                        direction="row"
                      >
                        <Typography variant="h6">{t("Comments")}</Typography>
                      </StyledPaperHeader>
                      <div style={{ padding: "10px" }}>
                        <Field
                          name="comments"
                          render={({ input }) => (
                            <TextField
                              className="MuiFormControl-root-MuiTextField-root"
                              {...input}
                              aria-label="minimum height"
                              multiline
                              rows={3}
                              variant="outlined"
                              placeholder={t("writeYourCommentsHere")}
                              disabled={disabled}
                            />
                          )}
                        />
                      </div>
                    </StyledPaper>

                    {/* Document Section */}
                    <Grid>
                      <PreAuthDocs
                        setAttachments={setAttachments}
                        claimData={preAuthFormData && preAuthFormData[0]}
                        disabled={disabled}
                      />
                    </Grid>
                    {!hideMenu && (
                      <div>
                        {url && (
                          <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={handleSubmitForApproval}
                            disabled={
                              disabled ||
                              (!pristine && Object.keys(errors).length === 0) ||
                              cannotBeSentWithActualStatus
                            }
                            style={{ float: "right", marginRight: "5px" }}
                          >
                            {t("Send for Approval")}
                          </Button>
                        )}

                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={
                            disabled &&
                            (pristine ||
                              Object.keys(errors).length > 0 ||
                              saving)
                          }
                          style={{ float: "right", marginRight: "5px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "4px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {t("SaveasDraft")}
                            {saving && <CircularProgress />}
                          </div>
                        </Button>
                      </div>
                    )}
                  </form>
                )}
              />
            </Grid>
          </div>
        }
      />
      <CommonSnackbar
        open={snackbarOption.visible}
        onClose={closeSnackbar}
        message={snackbarOption.message}
        severity={snackbarOption.severity}
      />
    </Grid>
  );
};

export default PreAuthDetails;
